module.exports = __webpack_public_path__ + "b9831a711b4c08ad0c32311dadec5742.png";